module.exports = __webpack_public_path__ + "static/media/list.e5724520.svg";